import { useQuery } from '@tanstack/react-query'
import { Gift } from 'lucide-react'
import { decorApi, wearing } from '@/lib/decor'
import type { Achievement } from '@/lib/achieve'
import { useAppStore } from '@/store/app'
import { Modal } from './Modal'
import { DecorPreview, type Look } from './DecorPreview'
import layer from './SettingsLayer.module.css'
import styles from './RewardsModal.module.css'

const lowerFirst = (s: string) => s.slice(0, 1).toLocaleLowerCase('ru') + s.slice(1)

/** Предпросмотр наград достижения: как вас увидят с ними — поверх того, что надето сейчас. */
export function RewardsModal({ achievement: a, onClose }: { achievement: Achievement; onClose: () => void }) {
  const { data } = useQuery({ queryKey: ['decorations'], queryFn: decorApi.inventory })
  const setView = useAppStore((s) => s.setView)
  const closeSettings = useAppStore((s) => s.closeSettings)
  const showContent = useAppStore((s) => s.showContent)
  const cur = data?.current
  const base: Look = {
    frame: cur?.avatar_decoration ?? null, effect: cur?.profile_effect ?? null, plate: cur?.nameplate ?? null,
    style: cur?.display_name_styles ?? null, theme: cur?.theme_colors ?? null,
    tag: data?.server_tags.find((t) => t.guild_id === cur?.server_tag) ?? null,
  }
  const done = a.earned_at !== null
  return (
    <Modal title={`Награды за «${a.name}»`} onClose={onClose} width={420}>
      <div className={styles.body}>
        <p className={styles.lead}>{done ? 'Получено — надеть можно в магазине.' : `Чтобы получить: ${lowerFirst(a.description)}.`}</p>
        <ul className={styles.list}>
          {a.rewards.map((r) => (
            <li key={r.item} className={styles.item}><Gift size={14} aria-hidden="true" /> {r.name}</li>
          ))}
        </ul>
        <div className={styles.preview}>
          <DecorPreview look={wearing(base, a.rewards.map((r) => r.item))} />
        </div>
        {done ? (
          <button
            type="button"
            className={layer.button}
            onClick={() => {
              closeSettings()
              setView({ kind: 'home', page: 'shop' })
              showContent() // на телефоне — сразу магазин, а не список бесед
              onClose()
            }}
          >
            Надеть в магазине
          </button>
        ) : null}
      </div>
    </Modal>
  )
}
